



















import Vue from "vue";
import { InstallationStatusEnum, installationStatusEnumLabel } from "@/model/data/status/InstallationStatusEnum";

export default Vue.extend({
    data() {
        return {
            // InstallationStatusEnum,
            selection: [],
        };
    },
    computed: {
        availableData() {
            return Object.values(InstallationStatusEnum).filter((x) => !isNaN(parseInt(x.toString())));
        },
    },
    watch: {
        selection() {
            this.$emit("input", this.selection);
        },
    },
    methods: {
        installationStatusEnumLabel,
    },
});
